import {createStore, type StoreApi} from 'zustand'
import {createGameGeneralSlice, type GameGeneralSlice, type GameGeneralSliceProps} from './slices/gameGeneralSlice.ts'
import {createGameVoteSlice, type GameVoteSlice, type GameVoteSliceProps} from './slices/gameVoteSlice.ts'
import {createGameTradeSlice, type GameTradeSlice, type GameTradeSliceProps} from './slices/gameTradeSlice.ts'
import {createGameSettingsSlice, type GameSettingsSlice, type GameSettingsSliceProps} from './slices/gameSettingsSlice.ts'
import {createGameModeSlice, type GameModeSlice, type GameModeSliceProps} from './slices/gameModeSlice.ts'
import {createGameStateSlice, type GameStateSlice, type GameStateSliceProps} from './slices/gameStateSlice.ts'
import {createGameUserStatesSlice, type GameUserStatesSlice, type GameUserStatesSliceProps} from './slices/gameUserStatesSlice.ts'
import {createGameDetailsSlice, type GameDetailsSlice, type GameDetailsSliceProps} from './slices/gameDetailsSlice.ts'
import {createGameUserSettingsSlice, type GameUserSettingsProps, type GameUserSettingsSlice} from './slices/gameUserSettingsSlice.ts'
import {createGameActionBoxSlice, type GameActionBoxSlice} from './slices/gameActionBoxSlice.ts'
import {createGameReplaySlice, type GameReplaySlice, type GameReplaySliceProps} from './slices/gameReplaySlice.ts'
import {createGameEndSlice, type GameEndSlice} from './slices/gameEndSlice.ts'
import {createGameBeginnerHintSlice, type GameBeginnerHintSlice} from './slices/gameBeginnerHintSlice.ts'
import {createGamePauseSlice, type GamePauseSlice, type GamePauseSliceProps} from './slices/gamePauseSlice.ts'
import {createGameActionButtonsSlice, type GameActionButtonsSlice} from './slices/gameActionButtonsSlice.ts'
import {createGameCardAnimatorSlice, type GameCardAnimatorSlice} from './slices/gameCardAnimatorSlice.ts'
import {createGameCardInventorySlice, type GameCardInventorySlice} from './slices/gameCardInventorySlice.ts'
import {createGameMuteSlice, type GameMuteSlice} from './slices/gameMuteSlice.ts'

export type GameStoreType =
    GameGeneralSlice
    & GameStateSlice
    & GameUserStatesSlice
    & GameVoteSlice
    & GameTradeSlice
    & GameSettingsSlice
    & GameModeSlice
    & GameDetailsSlice
    & GameUserSettingsSlice
    & GameActionBoxSlice
    & GameReplaySlice
    & GameEndSlice
    & GameBeginnerHintSlice
    & GamePauseSlice
    & GameCardAnimatorSlice
    & GameActionButtonsSlice
    & GameCardInventorySlice
    & GameMuteSlice

export type GameStore = StoreApi<GameStoreType>

export interface GameStoreProps {
    gameGeneral: GameGeneralSliceProps
    gameState: GameStateSliceProps
    gameUserStates: GameUserStatesSliceProps
    gameVote: GameVoteSliceProps
    gameTrade: GameTradeSliceProps
    gameSettings: GameSettingsSliceProps
    gameMode: GameModeSliceProps
    gameDetails: GameDetailsSliceProps
    gameUserSettings: GameUserSettingsProps
    gamePause: GamePauseSliceProps
    gameReplay: GameReplaySliceProps
}

export const createGameStore = ({
    gameGeneral,
    gameState,
    gameUserStates,
    gameVote,
    gameTrade,
    gameSettings,
    gameMode,
    gameDetails,
    gameUserSettings,
    gamePause,
    gameReplay,
}: GameStoreProps) => createStore<GameStoreType>((set, get, api) => ({
    ...createGameGeneralSlice(gameGeneral)(set, get, api),
    ...createGameStateSlice(gameState)(set, get, api),
    ...createGameUserStatesSlice(gameUserStates)(set, get, api),
    ...createGameVoteSlice(gameVote)(set, get, api),
    ...createGameTradeSlice(gameTrade)(set, get, api),
    ...createGameSettingsSlice(gameSettings)(set, get, api),
    ...createGameModeSlice(gameMode)(set, get, api),
    ...createGameDetailsSlice(gameDetails)(set, get, api),
    ...createGameUserSettingsSlice(gameUserSettings)(set, get, api),
    ...createGameActionBoxSlice()(set, get, api),
    ...createGameReplaySlice(gameReplay)(set, get, api),
    ...createGameEndSlice()(set, get, api),
    ...createGameBeginnerHintSlice()(set, get, api),
    ...createGamePauseSlice(gamePause)(set, get, api),
    ...createGameCardAnimatorSlice()(set, get, api),
    ...createGameActionButtonsSlice(set, get, api),
    ...createGameCardInventorySlice()(set, get, api),
    ...createGameMuteSlice()(set, get, api),
}))
